import Vue from "vue";
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength,
  minValue,
} from "vuelidate/lib/validators";
import users from "../../users";
import "../../filters";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";
import moment from "moment";

export default {
  name: "createAgreement",
  mixins: [users, validationMixin],
  props: ["dataObj"],
  components: {
    DataGridComp: require("../../customcontrols/datagrid.vue").default,
    datetime: Datetime,
    DateTime,
    reportsComp: require("../../common/reports/reports.vue").default,
  },
  validations: {
    agreement: {
      installmentAmount: {
        required,
        minValue: minValue(0.01),
      },
      installmentCount: {
        required,
        minValue: minValue(1),
      },
      initialAmount: {
        required,
        minValue: minValue(0),
      },
      chargeMonth: {
        required,
        minValue: minValue(1),
      },
      chargeDay: {
        required,
        minValue: minValue(1),
      },
      penaltyValue: {
        minValue: minValue(0),
      },
    },
  },
  data: function () {
    return {
      account: "",
      agreemNo: 0,
      agreement: {},
      activeTab: "tabSelectCustomer",
      settings: {},
      billingGroups: [],
      customers: [],
      customersCols: [],
      keyColumn: "account",
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      filters: {
        billingGroupId: "",
        consumerTypeId: null,
        customerKey: "",
        filter: "",
      },
      selectedCustomer: {},
      //agreement: {},
      selectedAgreemTypeId: 0,
      chargeSchedule: 0,
      installments: [],
      installmentDescribe: "",
      selectedPenaltyType: 0,
      selectedPenaltyValue: 0,
      installmentsPenaltyValues: [],
      effectiveDateFormatted: "",
      installmentsStartDate: null,
      installmentsStartDateView: null,
      bConfirmAgreementShow: false,
      bDeleteAgreementShow: false,
      showReportsDialog: false,
      reports: [],
    };
  },
  computed: {
    //agreementAmount() {
    //  return this.agreement.agreementAmount;
    //},
    installmentType() {
      return this.agreement.installmentType;
    },
    //installmentAmount() {
    //  return this.agreement.installmentAmount;
    //},
    //installmentCount() {
    //  return this.agreement.installmentCount;
    //},
    penaltyType() {
      return this.agreement.penaltyType;
    },
    //penaltyValue() {
    //  return this.agreement.penaltyValue;
    //}
  },
  watch: {
    installmentsStartDateView: function (val) {
      this.installmentsStartDate = moment(val, "DD/MM/YYYY"); //.add(1, 'days');
      this.calculateInstallments();
    },
    //agreementAmount: function (val) {
    //  this.calculateInstallments();
    //},
    installmentType: function (val) {
      this.calculateInstallments();
    },
    //installmentAmount: function (val) {
    //  this.calculateInstallments();
    //},
    //installmentCount: function (val) {
    //  this.calculateInstallments();
    //},
    //chargeSchedule: function (val) {
    //  this.calculateInstallments();
    //},
    penaltyType: function (val) {
      this.calculateInstallments();
    },
    //penaltyValue: function (val) {
    //  this.calculateInstallments();
    //}
  },
  created() {
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.account = this.$route.params.account;
    this.agreemNo = this.$route.params.no;

    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.fillCustomersCols();
        this.getSettings();

        console.log(this.account);

        if (this.account) {
          this.activeTab = "tabAgreementDtl";
          this.getAgreement();
        } else {
          this.getBillingGroups();
        }
      });
    },
    getSettings() {
      axios
        .get("/CustomerAgreement/GetSettings")
        .then((response) => {
          this.settings = response.data;
          //this.filters.agreementStatus = this.settings.agreementStatuses.length == 0 ? -1 : this.settings.agreementStatuses[0].id;
          console.log(response);
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getAgreement() {
      const parameters = {
        account: this.account,
        agreemNo: this.agreemNo,
      };

      axios
        .post("/CustomerAgreement/GetCustomerAgreement", parameters)
        .then((response) => {
          if (response.data.status !== 3) {
            var route = `/agreementDetails/${response.data.account}/${response.data.agreemNo}`;
            this.$router.push(route);
            return;
          }

          response["completionDate"] = response["lastInstallmentDate"];
          this.agreement = response.data;
          this.selectedAgreemTypeId = response.data.agreementTypeId;
          this.effectiveDateFormatted = moment(
            response.data.effectiveDate
          ).format("DD/MM/YYYY");
          this.getCustomerAgreementInstallmentsAndBalance();
          this.getReports();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getCustomerAgreementInstallmentsAndBalance() {
      axios
        .post(
          "/CustomerAgreement/GetCustomerAgreementInstallmentsAndBalance?account=" +
            this.account +
            "&agreemNo=" +
            this.agreemNo +
            "&pageIndex=1&pageSize=1000"
        )
        .then((response) => {
          response["completionDate"] = response["lastInstallmentDate"];
          this.agreement.balance = response.data.balance;

          const ins = [];
          for (var i = 0; i < response.data.items.length; i++) {
            const penalty =
              this.agreement.penaltyType === 0
                ? 0
                : this.agreement.penaltyType === 1
                ? Number(
                    (
                      (response.data.items[i].amount *
                        this.agreement.penaltyValue) /
                      100
                    ).toFixed(2)
                  )
                : this.agreement.penaltyType === 2
                ? +this.agreement.penaltyValue
                : 0;

            ins.push({
              instNo: i + 1,
              chargeDate: response.data.items[i].chargeDate,
              chargeDateView: moment(response.data.items[i].chargeDate).format(
                "DD/MM/YYYY"
              ),
              chargeCycle: `${this.$t("activities.billingCycle")} ${i + 1}`,
              amount: response.data.items[i].amount,
              penalty,
              total: +response.data.items[i].amount + +penalty,
            });
          }

          this.installments = ins;

          this.installmentsStartDate = response.data.items[0].chargeDate;
          this.installmentsStartDateView = moment(
            response.data.items[0].chargeDate
          ).format("DD/MM/YYYY");
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getBillingGroups() {
      axios
        .post("/CustomerAgreement/GetBillingGroups")
        .then((response) => {
          this.billingGroups = response.data;
          console.log(response);
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    fillCustomersCols() {
      this.customersCols.push({
        dataField: "billingGroup",
        caption: this.$t("activities.billingGroup"),
      });
      this.customersCols.push({
        dataField: "account",
        caption: this.$t("activities.account"),
      });
      this.customersCols.push({
        dataField: "name",
        caption: this.$t("activities.surname"),
      });
      this.customersCols.push({
        dataField: "consumerType",
        caption: this.$t("activities.consumerType"),
      });
      this.customersCols.push({
        dataField: "mailAddress",
        caption: this.$t("activities.address"),
      });
    },
    changeTab(e) {
      this.activeTab = e;
    },
    getCustomers() {
      const params = {
        billingGroupId: this.filters.billingGroupId,
        consumerTypeId:
          this.filters.consumerTypeId == null
            ? ""
            : this.filters.consumerTypeId,
        filterAccount: this.filters.customerKey,
        filter: this.filters.filter,
        pageIndex: this.options.page,
        pageSize: this.options.pageSize,
      };
      axios
        .post("/CustomerAgreement/GetCustomers", params)
        .then((response) => {
          console.log(response);

          this.customers = response.data.items;
          this.totalRow = response.data.totalCount;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    clearFilters() {
      this.filters = {
        billingGroupId: "",
        consumerTypeId: null,
        customerKey: "",
        filter: "",
      };
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getCustomers();
    },
    onSelectCustomer(info) {
      console.log(info);
      if (info.rowIndex < 0) return;

      this.selectedCustomer = this.customers[info.rowIndex];
      this.validateCustomer();
      console.log(this.selectedCustomer);
    },
    validateCustomer() {
      axios
        .post(
          "/CustomerAgreement/ValidateCustomer?account=" +
            this.selectedCustomer.account
        )
        .then((response) => {
          console.log(response);
          this.selectedCustomer = response.data;
          this.createNewCustomerAgreement();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    createNewCustomerAgreement() {
      axios
        .post(
          "/CustomerAgreement/CreateNewCustomerAgreement?account=" +
            this.selectedCustomer.account
        )
        .then((response) => {
          response.data.installmentCount = 0;
          this.agreement = response.data;
          this.effectiveDateFormatted = moment(
            this.agreement.effectiveDate
          ).format("DD/MM/YYYY");
          this.installmentsStartDateView =
            this.$options.filters.formatDateDDMMYYY(
              this.agreement.effectiveDate
            );
          this.activeTab = "tabAgreementDtl";
          console.log(response);
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getValidationClass(obj1, obj2) {
      let field = null;

      field = this.$v[obj1][obj2];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    refreshInstallments() {
      if (this.agreement.installmentType == 0) {
        axios
          .post(
            "/CustomerAgreement/CreateInstallmentsByAmount?totalAmount=" +
              this.agreement.agreementAmount +
              "&installmentAmount=" +
              this.agreement.installmentAmount
          )
          .then((response) => {
            console.log(response);
            this.installments = response.data;

            this.fillInstallments();
          })
          .catch((error) => {
            this.$alertMsg(error.response.data);
          });
      } else {
        axios
          .post(
            "/CustomerAgreement/CreateInstallmentsByCount?totalAmount=" +
              this.agreement.agreementAmount +
              "&installmentCount=" +
              this.agreement.installmentCount
          )
          .then((response) => {
            console.log(response);
            this.installments = response.data;

            this.fillInstallments();
          })
          .catch((error) => {
            this.$alertMsg(error.response.data);
          });
      }
    },
    fillInstallments() {
      this.selectedPenaltyType = JSON.parse(
        JSON.stringify(this.agreement.penaltyType)
      );
      this.selectedPenaltyValue = JSON.parse(
        JSON.stringify(this.agreement.penaltyValue)
      );
      this.installmentDescribe =
        this.chargeSchedule == 1 ? "cycleNo" : "chargeDate";

      this.installmentsPenaltyValues = [];

      if (this.selectedPenaltyType != 0) {
        var pv = 0;
        for (var i = 0; i < this.installments.length; i++) {
          if (this.selectedPenaltyType == 1) {
            pv = Number(
              (
                (this.installments[i].amount * this.selectedPenaltyValue) /
                100
              ).toFixed(3)
            );
          } else if (this.selectedPenaltyType == 2) {
            pv = Number(this.selectedPenaltyValue);
          }

          this.installmentsPenaltyValues.push({
            value: pv,
            total: this.installments[i].amount + pv,
          });
        }
      }
    },
    insertOrUpdateCustomerAgreement() {
      const ins = [];
      for (var i = 0; i < this.installments.length; i++) {
        ins.push({
          instNo: this.installments[i].instNo,
          chargeDate: new Date(
            new Date(this.installments[i].chargeDate).setDate(
              new Date(this.installments[i].chargeDate).getDate() + 1
            )
          ),
          amount: this.installments[i].amount,
        });
      }

      let parameters = {
        Account: this.agreement.account,
        AgreemNo: this.agreemNo == undefined ? 0 : this.agreemNo,
        AgreementAmount: this.agreement.agreementAmount,
        AgreementTypeId: this.selectedAgreemTypeId,
        EffectiveDate: this.agreement.effectiveDate,
        Schedule: this.chargeSchedule,
        InstallmentType: this.agreement.installmentType,
        InstallmentCount: this.installments.length,
        InstallmentAmount: this.agreement.installmentAmount,
        ImmediatePayment: 0,
        PenaltyType: this.agreement.penaltyType,
        PenaltyValue: this.agreement.penaltyValue,
        GuarantorName:
          this.agreement.guarantorName == null
            ? ""
            : this.agreement.guarantorName,
        GuarantorAddress:
          this.agreement.guarantorAddress == null
            ? ""
            : this.agreement.guarantorAddress,
        GuarantorId:
          this.agreement.guarantorId == null ? "" : this.agreement.guarantorId,
        GuarantorTel:
          this.agreement.guarantorTel == null
            ? ""
            : this.agreement.guarantorTel,
        GuarantorEmail:
          this.agreement.guarantorEmail == null
            ? ""
            : this.agreement.guarantorEmail,
        Remarks: this.agreement.remarks == null ? "" : this.agreement.remarks,
        OldKey: this.agreement.oldKey == null ? "" : this.agreement.oldKey,
        Installments: ins,
      };

      axios
        .post("/CustomerAgreement/InsertOrUpdateCustomerAgreement", parameters)
        .then((response) => {
          console.log(response);
          this.$alertMsg(
            this.$t(
              "customerAgreements.createAgreementHasBeenDoneSuccessfully"
            ),
            2
          );

          if (!this.agreemNo) this.getReports();

          this.agreemNo = response.data;

          //this.account = this.agreement.account;

          //this.activeTab = 'tabAgreementDtl';
          //this.getAgreement();

          //if (this.agreement.agreementAmount <= this.settings.authorizeLimit)
          //  this.authorizeCustomerAgreement(response.data);
          //else {
          //  this.$alertMsg(this.$t('customerAgreements.createAgreementHasBeenDoneSuccessfully'));
          //  this.$router.go(-1);
          //}
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    authorizeCustomerAgreement() {
      axios
        .post(
          "/CustomerAgreement/AuthorizeCustomerAgreement?account=" +
            this.agreement.account +
            "&agreemNo=" +
            this.agreemNo
        )
        .then((response) => {
          this.$alertMsg(
            this.$t(
              "customerAgreements.createAgreementHasBeenDoneSuccessfully"
            ),
            2
          );
          this.$router.push({ path: "/agreements" });
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    calculateInstallments() {
      const installments = [];

      let insCnt = 0;
      let insAmount = 0;

      if (this.agreement.installmentType === 1) {
        insCnt = this.agreement.installmentCount;

        insAmount =
          this.agreement.installmentCount === 0
            ? 0
            : Number(
                (
                  this.agreement.agreementAmount /
                  this.agreement.installmentCount
                ).toFixed(3)
              );
      } else {
        insCnt =
          this.agreement.installmentAmount === 0
            ? 0
            : Math.ceil(
                this.agreement.agreementAmount /
                  this.agreement.installmentAmount
              );
        insAmount = this.agreement.installmentAmount;
      }

      //const startDate = new Date(this.installmentsStartDate);
      //console.log(this.installmentsStartDate);

      for (var i = 0; i < insCnt - 1; i++) {
        const penalty =
          this.agreement.penaltyType === 0
            ? 0
            : this.agreement.penaltyType === 1
            ? Number(
                ((insAmount * this.agreement.penaltyValue) / 100).toFixed(3)
              )
            : this.agreement.penaltyType === 2
            ? +this.agreement.penaltyValue
            : 0;

        installments.push({
          instNo: i + 1,
          chargeDate: new Date(
            new Date(this.installmentsStartDate).setMonth(
              new Date(this.installmentsStartDate).getMonth() + i
            )
          ),
          chargeDateView: moment(
            new Date(this.installmentsStartDate).setMonth(
              new Date(this.installmentsStartDate).getMonth() + i
            )
          ).format("DD/MM/YYYY"),
          chargeCycle: `${this.$t("activities.billingCycle")} ${i + 1}`,
          amount: insAmount,
          penalty,
          total: +insAmount + +penalty,
        });
      }

      const restAmount = Number(
        (this.agreement.agreementAmount - insAmount * (insCnt - 1)).toFixed(3)
      );

      const penalty =
        this.agreement.penaltyType === 0
          ? 0
          : this.agreement.penaltyType === 1
          ? Number(
              ((restAmount * this.agreement.penaltyValue) / 100).toFixed(3)
            )
          : this.agreement.penaltyType === 2
          ? +this.agreement.penaltyValue
          : 0;

      installments.push({
        instNo: +insCnt,
        chargeDate: new Date(
          new Date(this.installmentsStartDate).setMonth(
            new Date(this.installmentsStartDate).getMonth() + (insCnt - 1)
          )
        ),
        chargeDateView: moment(
          new Date(this.installmentsStartDate).setMonth(
            new Date(this.installmentsStartDate).getMonth() + (insCnt - 1)
          )
        ).format("DD/MM/YYYY"),
        chargeCycle: `${this.$t("activities.billingCycle")} ${+insCnt}`,
        amount: restAmount,
        penalty,
        total: +restAmount + +penalty,
      });

      console.log(installments);
      this.installments = installments;
    },
    deleteCustomerAgreement() {
      axios
        .post(
          "/CustomerAgreement/DeleteCustomerAgreement?account=" +
            this.agreement.account +
            "&agreemNo=" +
            this.agreemNo
        )
        .then((response) => {
          this.$alertMsg(
            this.$t(
              "customerAgreements.deleteAgreementHasBeenDoneSuccessfully"
            ),
            2
          );
          this.$router.push({ path: "/agreements" });
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getReports() {
      axios
        .get("/CustomerAgreement/GetReports")
        .then((response) => {
          if (response.status == 200) {
            this.reports = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    printReport(reportId) {
      axios
        .post(
          "/CustomerAgreement/CreateReport?reportId=" +
            reportId +
            "&account=" +
            this.agreement.account +
            "&agreemNo=" +
            this.agreemNo
        )
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, "_blank");
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
        );
    },
  },
};
